import * as React from 'react';
import { SVGProps } from 'react';

const IconQuoteSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 4v5h2.75L10 12h2.25L14 9V4H9zM2 9h2.75L3 12h2.25L7 9V4H2v5z" />
  </svg>
);
export default IconQuoteSizeS;
